import React from 'react'
import { observer } from 'mobx-react'
import scrollToTop from 'decorators/scrollToTop'
import { CheckList, CheckListItem } from 'components/CheckList'
import { FlexContainer, FlexItem } from 'components/Flex'
import './styles.sass'

@scrollToTop
@observer
export default class TaxStatesStep extends React.Component {
  render () {
    return (
      <div className="tax-states-step">
        <FlexContainer direction="column" alignItems="center">
          <FlexItem>
            <CheckList>
              {this.props.step.relevantStates.map((state) => (
                <CheckListItem
                  checked={state.selected}
                  onChange={newVal => state.setSelected(newVal)}
                  key={state.name}
                >
                  {state.name}
                </CheckListItem>
              ))}
            </CheckList>
          </FlexItem>
        </FlexContainer>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/client/screens/ProjectWizard/Steps/TaxStates/index.jsx